'use client'

import cx from 'classnames'
import React from 'react'
import { useRecoilState } from 'recoil'

import { debutSliderState } from '@/components/Page/Teaser/Introduction/Debut/InViewDebutLogic'

export default function ButtonView() {
  const [selectIndex, setSelectIndex] = useRecoilState(debutSliderState)
  return (
    <div className={cx('w-full', 'flex', 'z-30', 'absolute', 'bottom-[30px]', ...['sm:bottom-[78px]'])}>
      <div
        className={cx('flex-1', 'text-center', {
          'cursor-pointer': selectIndex !== 0,
          'hover:animate-[hover_.5s_ease-out_both]': selectIndex !== 0,
        })}
        onClick={() => setSelectIndex(0)}
      >
        <div
          className={cx('text-white', 'animate-[re-hover_0.5s_ease-out_both]', {
            'hover:animate-[hover_0.5s_ease-out_both]': selectIndex !== 0,
          })}
        >
          <p
            className={cx(
              'font-goldenbook',
              'text-[12px]',
              'tracking-[.24px]',
              'mb-[9px]',
              ...['sm:text-[18px]', 'sm:tracking-[.36px]'],
              {
                'opacity-50': selectIndex !== 0,
              }
            )}
          >
            FAS THE BLACK ESSENCE
          </p>
          <p
            className={cx('text-[10px]', 'tracking-[1px]', ...['sm:text-[11px]', 'sm:tracking-[1.1px]'], {
              'opacity-50': selectIndex !== 0,
              'opacity-80': selectIndex == 0,
            })}
          >
            ザ ブラック エッセンス
          </p>
        </div>
      </div>
      <div
        className={cx('flex-none', 'border-l', 'border-solid', {
          'hover:animate-[hover_.5s_ease-out_both]': selectIndex !== 1,
        })}
        style={{ borderColor: 'rgba(255,255,255,.2)' }}
      ></div>
      <div
        className={cx('flex-1', 'text-center', {
          'cursor-pointer': selectIndex !== 1,
          'hover:animate-[hover_.5s_ease-out_both]': selectIndex !== 1,
        })}
        onClick={() => setSelectIndex(1)}
      >
        <div
          className={cx('text-white', 'animate-[re-hover_0.5s_ease-out_both]', {
            'hover:animate-[hover_0.5s_ease-out_both]': selectIndex !== 1,
          })}
        >
          <p
            className={cx(
              'font-goldenbook',
              'text-[12px]',
              'tracking-[.24px]',
              'mb-[9px]',
              ...['sm:text-[18px]', 'sm:tracking-[.36px]'],
              {
                'opacity-50': selectIndex !== 1,
              }
            )}
          >
            FAS THE BLACK CREAM
          </p>
          <p
            className={cx('text-[10px]', 'opacity-80', 'tracking-[1px]', ...['sm:text-[11px]', 'sm:tracking-[1.1px]'], {
              'opacity-50': selectIndex !== 1,
              'opacity-80': selectIndex != 1,
            })}
          >
            <span className={cx('block', 'mb-[4px]')}>ザ ブラック クリーム</span>[ 医薬部外品 ]
          </p>
        </div>
      </div>
    </div>
  )
}
